import React from 'react';
import {
  tile,
  image,
  block100,
  block80,
  block60,
  block40,
  block40Container,
  animate,
} from './styles.module.css';

const LoadingEventTile = () => {
  return (
    <div className={tile}>
      <div className={`${image} ${animate}`}></div>
      <div className={`${block100} ${animate}`}></div>
      <div className={`${block80} ${animate}`}></div>
      <div className={`${block60} ${animate}`}></div>
      <div className={block40Container}>
        <span className={`${block40} ${animate}`}></span>
        <span className={`${block40} ${animate}`}></span>
      </div>
    </div>
  );
};

export default LoadingEventTile;
